import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {isPropertyTypeAll} from '../../utils/property-types';
import {fetchReviews} from './redux.js';

import {
    CACHE as LOADING_CACHE,
    placeholderFromType,
} from '../../components/common/loading';

export const mapStateToProps = ({
    config: {
        url: {basePathPrefix},
    },
    destination: {
        details: {lbsId, simpleName: destinationName, fullName},
        propertyType,
    },
    marketingLocalization: {preposition = ''},
    options: {isShowBrandHeadings = false},
}) => ({
    basePathPrefix,
    destinationName,
    lbsId,
    fullName,
    refinementKey: !isPropertyTypeAll(propertyType) ? propertyType : '',
    preposition,
    isShowBrandHeadings,
});

export class ReviewsLoaderComponent extends Component {
    static propTypes = {
        basePathPrefix: PropTypes.string,
        destinationName: PropTypes.string,
        lbsId: PropTypes.string,
        fullName: PropTypes.string,
        refinementKey: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ]),
        preposition: PropTypes.string,
        isShowBrandHeadings: PropTypes.bool,
    };

    componentDidMount() {
        this.props.dispatch(fetchReviews(this.props));
    }

    render() {
        return <Fragment>{placeholderFromType(ReviewsLoader)}</Fragment>; // eslint-disable-line no-use-before-define
    }
}

export const ReviewsLoader = connect(mapStateToProps)(ReviewsLoaderComponent);

ReviewsLoader.displayName = 'ReviewsLoader';

export default ReviewsLoader;

LOADING_CACHE.set(ReviewsLoader, {
    cardType: 'CardType3',
    componentType: 'ReviewsLoader',
    placeholderType: 'Carousel',
    size: 'lg',
});
